
import { MAIN_URL, REQUEST_URL } from "../../constant/ApplicationVariables";
import { axiosInstance } from "../useAxios/useAxios";

// const axiosInstance = axiosInstance;

export const getExecutionFolderList_API = async (query) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.folderStructureExecution + `?${query}`,
            method: "GET",
            // data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
}


export const getTestSetDetail_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.testSetDetail,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
}

export const updateTestSetDetail_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.testSetDetail,
            method: "PUT",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
}


export const addTestSet_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.testSet,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
}

export const updateDeleteTestSet_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.testSet,
            method: "PUT",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
}



export const getTestSet_AllTestCaseList_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.execution,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
}


export const executeTestCaseManual_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.executionManual,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
}

export const getTestCaseExecutionDetail_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.executionTestCase,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
}

export const getTestCaseExecutionList_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.executionTestCaseList,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
}

export const getExecutionTestCaseDetail_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.executionTestCaseDetail,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
}

export const deleteExecutions_API = async (executionIds) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.execution,
            method: "DELETE",
            data: { executionIds: executionIds },
            contentType: "application/json"
        });
        console.log(response, "delete executions response");
        return response
    } catch (error) {
        console.log(error, "delete executions error");
        throw error; // Throw error to handle in component
    }
}


/**
 * Export execution test case report to Excel
 * @param {Object} body - Same payload as getTestCaseExecutionDetail_API
 * @returns {Promise<Blob>} - Excel file blob
 */
export const exportExecutionToExcel_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.executionExportExcel,
            method: "POST",
            data: body,
            responseType: 'blob', // Important: tells axios to handle binary data
            contentType: "application/json"
        });
        return response;
    } catch (error) {
        console.error("Export execution to Excel error:", error);
        throw error;
    }
};

/**
 * Download execution report as Excel file with automatic file save
 * @param {Object} body - Same payload as getTestCaseExecutionDetail_API
 * @param {string} defaultFilename - Optional custom filename (server will provide default)
 * @returns {Promise<boolean>} - Success status
 */
export const downloadExecutionReportAsExcel = async (body, defaultFilename = 'execution-report') => {
    try {
        const response = await exportExecutionToExcel_API(body);
        
        // Get filename from Content-Disposition header or use default
        let filename = `${defaultFilename}.xlsx`;
        const contentDisposition = response.headers?.['content-disposition'];
        
        if (contentDisposition) {
            // Try to extract filename from Content-Disposition header
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
                filename = filenameMatch[1].replace(/['"]/g, '');
            }
        }
        
        // Create blob URL and trigger download
        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        return true;
    } catch (error) {
        console.error("Download execution report error:", error);
        throw error;
    }
};

/**
 * Export execution report using execution details (convenience method)
 * @param {Object} execution - Execution object from list/dashboard
 * @returns {Promise<boolean>} - Success status
 */
export const exportExecutionReport = async (execution) => {
    const payload = {
        executionId: execution.executionId,
        testSetName: execution.testSetName || '',
        customId: execution.customId,
        folderPath: execution.folderPath || '',
        projectName: execution.projectName || '',
        releaseName: execution.releaseName || ''
    };
    
    // Create sanitized filename
    const sanitizedId = (execution.customId || execution.executionId || 'report')
        .replace(/[^a-z0-9]/gi, '_')
        .toLowerCase()
        .substring(0, 80);
    const mode = execution.mode === 'Manual' ? 'manual' : 'automation';
    const filename = `execution-${sanitizedId}-${mode}`;
    
    return downloadExecutionReportAsExcel(payload, filename);
};